/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { EntityFileExplorerItem, EntityFileResponseItem, VirusScanStatus } from '../../Entities';

export const mapFileToExplorerItem = (file: EntityFileResponseItem): EntityFileExplorerItem => {
  return {
    access: file.access,
    contentType: file.contentType,
    id: file.fileId,
    lastModified: file.updatedAt,
    path: file.source,
    size: file.size,
    type: 'OBJECT',
    urls: file.urls,
    virusScanStatus: file.virusScan as VirusScanStatus,
  };
};
